import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { profile, experience, education } from "../../data/resume";

// Employer and degree come from src/data/resume.js, so this card updates when
// the resume does. It previously read "I completed MCA in  Compute." - a
// sentence that had been cut off mid-word.
function AboutCard() {
  const currentRole = experience[0];
  const degree = education[0];

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone, I am <span className="purple">{profile.name} </span>
            from <span className="purple">{profile.location}.</span>
            <br />
            I currently work as a{" "}
            <span className="purple">{currentRole.role}</span> at{" "}
            <span className="purple">{currentRole.company}</span>.
            <br />
            I completed my <span className="purple">MCA</span> from{" "}
            {degree.institution} in {degree.end}.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "#94a3b8" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">{profile.name}</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
